import React ,{ useRef } from "react";
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    GuestListTableContainer, 
} from './owner.style';
import { gql, useMutation,useQuery } from '@apollo/client';
import {
    TableHead,
    TableBodyRow
} from '../../../../widget/styledComponents/table.style'
import Cookies from 'js-cookie';
import { Dialog,EditIcon,IconButton,Pagination,Pane,Spinner,TrashIcon, toaster } from 'evergreen-ui'
import { FieldBtn } from '../dues/dues.style';
import { AppInputField, AppInputFieldBtn, InputFieldTitleText } from "../../../../widget/styledComponents/input_field.style";
import AddAssetsPlaceholder from "../../../../widget/add_assets_placeholder";



export const FETCH_OWNERS_LIST = gql`
query Owners_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  owners_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    id
    email
    name
    phone
    photo
    facility
    isAccountActivated
    createdAt
  }
}
`;

function OwnerPageWidget() {
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_OWNERS_LIST,{
    variables: {
        facilityId:facilityId,
        pagination: {
            "cursor": null,
            "limit": 30
        },
     },
    });
  return (
    <div className=''>
        <br/><br/>
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                   Owner
                </PageTitleText>
            </div>
            
        </div>  

        <AddOwnerBtn facilityId={facilityId}/>
        
        <GuestListTableContainer>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>Name</TableHead>
                    <TableHead>email</TableHead>
                    <TableHead>phone</TableHead>
                    <TableHead>Edit</TableHead>
                    <TableHead>Delete</TableHead>
                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.owners_getByFacility.map((data) => 
                        <TableBodyRow>
                            <td>{data.name}</td>
                            <td>{data.email}</td>
                            <td>{data.phone}</td>
                            <td>
                               
                                <EditOwnerBtn data={data}/>
                            </td>
                            <td>
                                <DeleteOwnerBtn id={data.id} />
                            </td>
                           
                        </TableBodyRow>
                        )
                    }
                   
                </tbody>
            </table>
            <center>
              <AddAssetsPlaceholder/>
            </center>
            <Pagination className='transparent z-depth-0' page={1} totalPages={3}></Pagination>

                    
        </GuestListTableContainer>
    </div>
  )
}

export default OwnerPageWidget







export const ADD_OWNER = gql`
mutation Owner_initializeAccount($facilityId: ID!, $name: String!, $email: String!, $phone: String!) {
  owner_initializeAccount(facilityId: $facilityId, name: $name, email: $email, phone: $phone) {
    code
    success
    error
    token
  }
}
`;

function AddOwnerBtn(props) {
    const accesTokenValue = Cookies.get('userAccessToken');
    const [addOwner, { loading }] = useMutation(ADD_OWNER);
    const [isShown, setIsShown] = React.useState(false)

    const facilityId = props.facilityId;

    const handleSubmit=(e)=>{
        e.preventDefault()
        addOwner({
          variables: { 
            name: nameRef.current.value,
            email: emailRef.current.value,
            phone: phoneRef.current.value,
            facilityId
          },
          context: {
            headers: {
              Authorization: `Bearer ${accesTokenValue}`,
            },
          },
        })
        .then((response) => {
          toaster.success("Owner added successfully.")
          window.location.reload()
        })
        .catch((error) => {
          toaster.danger(error.message)
        });
    }

    const nameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);

        return (
          <Pane>
            <Dialog
              isShown={isShown}
              title="Add a new owner"
              onCloseComplete={() => setIsShown(false)}
              hasHeader={true}
              shouldCloseOnOverlayClick={false}
              shouldCloseOnEscapePress={false}
              hasFooter ={false}
            >
                
               
                <div className=''>
                <div>
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Name
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="Femi ojo"
                                    ref={nameRef}
                                required/> 
                            </div>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Email
                                </InputFieldTitleText>
                                <AppInputField
                                    type="email" 
                                    placholder="alijames@gmail.com"
                                    ref={emailRef}
                                required/> 
                            </div>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Phone number
                                </InputFieldTitleText>
                                <AppInputField
                                    type="tel" 
                                    placholder="0808-9984-4398"
                                    ref={phoneRef}
                                required/> 
                            </div>
                            
                            <div className='row'>
                                <div className='col s12 right' style={{
                                    display:"flex",
                                    flexWrap:"wrap",
                                    justifyContent:"end"
                                }}>
                                    <div className='' style={{
                                        width:"120px",
                                        padding:"16px "
                                    }}>
                                        {loading  &&
                                        <center>
                                            <Spinner/>
                                        </center>
                                        }
                                        {!loading &&
                                            <AppInputFieldBtn className='' disabled={loading}>
                                                Add
                                            </AppInputFieldBtn>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            <br/>
                    </div>
                    </form>
                </div>
                </div>
            </Dialog>
            <div className=''>
                <FieldBtn
                    onClick={() => setIsShown(true)}
                    class="mt-50 waves-effect waves-light btn-flat  ">
                    <i class="material-icons left">add</i>
                    Add New Owner
                </FieldBtn>
            </div>
    
          </Pane>
        )
}




export const EDIT_OWNER = gql`
mutation Owner_edit($ownerEditId: ID!, $name: String!, $phone: String!) {
  owner_edit(id: $ownerEditId, name: $name, phone: $phone) {
    code
    success
    error
    token
  }
}
`;
function EditOwnerBtn(props) {
    const accesTokenValue = Cookies.get('userAccessToken');
    const [editOwner, { loading }] = useMutation(EDIT_OWNER);
    const [isShown, setIsShown] = React.useState(false)

    const ownerData = props.data;

    const handleSubmit=(e)=>{
        e.preventDefault()
        editOwner({
          variables: { 
            name: nameRef.current.value,
            phone:phoneRef.current.value,
            ownerEditId:ownerData.id
          },
          context: {
            headers: {
              Authorization: `Bearer ${accesTokenValue}`,
            },
          },
        })
        .then((response) => {
          toaster.success("Owner added successfully.")
          window.location.reload()
        })
        .catch((error) => {
          toaster.danger(error.message)
        });
      }
    const nameRef = useRef(null);
    const phoneRef = useRef(null);
    

        return (
          <Pane>
            <Dialog
              isShown={isShown}
              title="Add a new owner"
              onCloseComplete={() => setIsShown(false)}
              hasHeader={true}
              shouldCloseOnOverlayClick={false}
              shouldCloseOnEscapePress={false}
              hasFooter ={false}
            >
                
               
                <div className=''>
                <div>
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Name
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="Femi ojo"
                                    ref={nameRef}
                                required/> 
                            </div>
                            
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Phone number
                                </InputFieldTitleText>
                                <AppInputField
                                    type="tel" 
                                    placholder="0808-9984-4398"
                                    ref={phoneRef}
                                required/> 
                            </div>
                            
                            <div className='row'>
                                <div className='col s12 right' style={{
                                    display:"flex",
                                    flexWrap:"wrap",
                                    justifyContent:"end"
                                }}>
                                    <div className='' style={{
                                        width:"120px",
                                        padding:"16px "
                                    }}>
                                        {loading  &&
                                        <center>
                                            <Spinner/>
                                        </center>
                                        }
                                        {!loading &&
                                            <AppInputFieldBtn className='' disabled={loading}>
                                                Update
                                            </AppInputFieldBtn>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            <br/>
                    </div>
                    </form>
                </div>
                </div>
            </Dialog>
            <div className=''>
                
                <IconButton
                onClick={() => setIsShown(true)}
                icon={EditIcon} intent="primary"  />
                
            </div>
    
          </Pane>
        )
}
  



export const DELETE_OWNER = gql`
mutation Owner_delete($ownerDeleteId: ID!) {
  owner_delete(id: $ownerDeleteId) {
    code
    success
    error
  }
}
`;
function DeleteOwnerBtn(props) {
    
    const accesTokenValue = Cookies.get('userAccessToken');
    const [deleteOwner, { loading }] = useMutation(DELETE_OWNER);
    const [isShown, setIsShown] = React.useState(false)

    const id= props.id;

    const handleSubmit=()=>{
        deleteOwner({
          variables: { 
            ownerDeleteId:id,
          },
          context: {
            headers: {
              Authorization: `Bearer ${accesTokenValue}`,
            },
          },
        })
        .then((response) => {
          toaster.success("Owner deleted successfully.")
          window.location.reload()
        })
        .catch((error) => {
        console.log("sded",error)
          toaster.danger(error.message)
        });
      }
  
    

        return (
          <Pane>

            <Dialog
                isShown={isShown}
                title="Delete Owner"
                intent="danger"
                onCloseComplete={() => setIsShown(false)}
                confirmLabel="Delete"
                isConfirmLoading={loading}
                shouldCloseOnEscapePress={false}
                shouldCloseOnOverlayClick={false}
                onConfirm={()=>handleSubmit()}
            >
                Are you sure you want to delete this owner?
            </Dialog>
            
            <IconButton
            onClick={() => setIsShown(true)}
            icon={TrashIcon} intent="danger"  />
          </Pane>
        )
}
  